module.exports = __webpack_public_path__ + "static/media/icon_2.c73d0969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/icon_2.svg
// module id = 540
// module chunks = 0